<script lang="ts" setup>
import { CollectionAccount } from '../types'

const props = defineProps<{
  collectibleDefinitions: {
    id: number;
    name: string;
    icon: string;
    type: string;
    watermark: string;
  }[],
  renegadesExotics: number[],
  edgeOfFateExotics: number[],
  finalShapeExotics: number[],
  lightfallExotics: number[],
  witchQueenExotics: number[],
  beyondLightExotics: number[],
  shadowkeepExotics: number[],
  forsakenExotics: number[],
  redWarExotics: number[],
  miscExotics: number[],
  player: CollectionAccount
}>()

function sortItems(itemList: number[]) {
  return itemList.sort((a, b) => {
    const itemA = props.collectibleDefinitions.find(x => x.id === a)
    const itemB = props.collectibleDefinitions.find(x => x.id === b)

    if (!itemA || !itemB) return 0

    return itemA.name.localeCompare(itemB.name)
  })
}
</script>

<template>
  <h3 class="font-sans text-xl -mt-4 pt-3 -mx-3 px-3 pb-1 w-[calc(100%+1.5rem)] sticky top-0 bg-zinc-200 border-zinc-400 border-b rounded-t-lg shadow-md">All exotics: {{ player.displayName }}</h3>

  <div class="font-sans">
    <h4 class="font-semibold mt-2 text-center">Renegades</h4>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-x-2 border-zinc-400 border-t pt-1">
      <span
        v-for="collectibleId in sortItems(renegadesExotics)"
        class="flex gap-1 text-sm"
        :class="{ 'text-zinc-900': player.items[collectibleId], 'text-zinc-400': !player.items[collectibleId] }"
      >
        {{ collectibleDefinitions.find(x => x.id === collectibleId)?.name }}
      </span>
    </div>

    <h4 class="font-semibold mt-2 text-center">Edge of Fate</h4>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-x-2 border-zinc-400 border-t pt-1">
      <span
        v-for="collectibleId in sortItems(edgeOfFateExotics)"
        class="flex gap-1 text-sm"
        :class="{ 'text-zinc-900': player.items[collectibleId], 'text-zinc-400': !player.items[collectibleId] }"
      >
        {{ collectibleDefinitions.find(x => x.id === collectibleId)?.name }}
      </span>
    </div>

    <h4 class="font-semibold mt-2 text-center">The Final Shape</h4>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-x-2 border-zinc-400 border-t pt-1">
      <span
        v-for="collectibleId in sortItems(finalShapeExotics)"
        class="flex gap-1 text-sm"
        :class="{ 'text-zinc-900': player.items[collectibleId], 'text-zinc-400': !player.items[collectibleId] }"
      >
        {{ collectibleDefinitions.find(x => x.id === collectibleId)?.name }}
      </span>
    </div>

    <h4 class="font-semibold mt-2 text-center">Lightfall</h4>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-x-2 border-zinc-400 border-t pt-1">
      <span
        v-for="collectibleId in sortItems(lightfallExotics)"
        class="flex gap-1 text-sm"
        :class="{ 'text-zinc-900': player.items[collectibleId], 'text-zinc-400': !player.items[collectibleId] }"
      >
        {{ collectibleDefinitions.find(x => x.id === collectibleId)?.name }}
      </span>
    </div>

    <h4 class="font-semibold mt-2 text-center">The Witch Queen</h4>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-x-2 border-zinc-400 border-t pt-1">
      <span
        v-for="collectibleId in sortItems(witchQueenExotics)"
        class="flex gap-1 text-sm"
        :class="{ 'text-zinc-900': player.items[collectibleId], 'text-zinc-400': !player.items[collectibleId] }"
      >
        {{ collectibleDefinitions.find(x => x.id === collectibleId)?.name }}
      </span>
    </div>

    <h4 class="font-semibold mt-2 text-center">Beyond Light</h4>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-x-2 border-zinc-400 border-t pt-1">
      <span
        v-for="collectibleId in sortItems(beyondLightExotics)"
        class="flex gap-1 text-sm"
        :class="{ 'text-zinc-900': player.items[collectibleId], 'text-zinc-400': !player.items[collectibleId] }"
      >
        {{ collectibleDefinitions.find(x => x.id === collectibleId)?.name }}
      </span>
    </div>
    
    <h4 class="font-semibold mt-2 text-center">Shadowkeep</h4>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-x-2 border-zinc-400 border-t pt-1">
      <span
        v-for="collectibleId in sortItems(shadowkeepExotics)"
        class="flex gap-1 text-sm"
        :class="{ 'text-zinc-900': player.items[collectibleId], 'text-zinc-400': !player.items[collectibleId] }"
      >
        {{ collectibleDefinitions.find(x => x.id === collectibleId)?.name }}
      </span>
    </div>
    
    <h4 class="font-semibold mt-2 text-center">Forsaken</h4>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-x-2 border-zinc-400 border-t pt-1">
      <span
        v-for="collectibleId in sortItems(forsakenExotics)"
        class="flex gap-1 text-sm"
        :class="{ 'text-zinc-900': player.items[collectibleId], 'text-zinc-400': !player.items[collectibleId] }"
      >
        {{ collectibleDefinitions.find(x => x.id === collectibleId)?.name }}
      </span>
    </div>
    
    <h4 class="font-semibold mt-2 text-center">Red War</h4>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-x-2 border-zinc-400 border-t pt-1">
      <span
        v-for="collectibleId in sortItems(redWarExotics)"
        class="flex gap-1 text-sm"
        :class="{ 'text-zinc-900': player.items[collectibleId], 'text-zinc-400': !player.items[collectibleId] }"
      >
        {{ collectibleDefinitions.find(x => x.id === collectibleId)?.name }}
      </span>
    </div>
    
    <h4 class="font-semibold mt-2 text-center">Misc.</h4>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-x-2 border-zinc-400 border-t pt-1">
      <span
        v-for="collectibleId in sortItems(miscExotics)"
        class="flex gap-1 text-sm"
        :class="{ 'text-zinc-900': player.items[collectibleId], 'text-zinc-400': !player.items[collectibleId] }"
      >
        {{ collectibleDefinitions.find(x => x.id === collectibleId)?.name }}
      </span>
    </div>
  </div>
</template>